import clsx from 'clsx'
import {React, useContext} from 'external/react'
import {makeStyles, Box} from 'external/material'
import {TeacherContext} from 'teacher/context'

const useStyles = makeStyles(styles)

export default function SubjectAndGradeHeader(props){

  const classes = useStyles()
  const context = useContext(TeacherContext)
  const {standard} = props
  const {grades, subjects, translate} = context
  const grade = grades.find(g => g.id == standard.grade)
  const subject = subjects.find(s => s.id == standard.subject)

  return (
    <Box className={classes.root}>
      <Box className={classes.name}>
        <Box className={clsx(classes.centered, classes.subject)}>
          {subject?.name || standard.subject}
        </Box>
        <Box className={clsx(classes.centered, classes.grade)}>
          {grade?.name || standard.grade}
        </Box>
      </Box>
      <Box className={clsx(classes.centered, classes.label)}>
        {translate('standards')}
      </Box>
    </Box>
  )
}

function styles () {
  return {
    root: {
      display: 'flex',
      flexDirection:'column',
      color: '#3f5250',
    },
    name: {
      display: 'flex',
      fontWeight: 'bold',
      fontSize: '18pt',
    },
    label: {
      fontSize: '16pt',
      marginTop: 10,
      padding: '15px 0',
      borderBottom: 'solid 1px #d8d8d8'
    },
    centered: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'centered'
    },
    grade: {
      marginLeft: 4
    }
  }
}
